<ion-header [translucent]="true">
  @if(item()){
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/inventory/towers"></ion-back-button>
      </ion-buttons>
      @if(uid()) {
        <ion-buttons slot="end">
          @if(item()?.id) {
            <ion-button (click)="confirmAlert(item()?.id ?? '')" data-testid="tower-detail-delete">
              <ion-icon
                slot="icon-only"
                color="danger"
                name="trash-outline"
              ></ion-icon>
            </ion-button>
          }
          <ion-button (click)="openHelpModal()">
            <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      }
      <ion-title>{{item()?.name}}</ion-title>
    </ion-toolbar>
  }
</ion-header>

<ion-content class="ion-padding">
  @if(item()) {
    <app-form
      [item]="item()"
      [uid]="uid()"
      (softUpdate)="softUpdate($event)"
    ></app-form>
  }

  <div class="ion-padding-top">
    <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
      <ion-text color="medium">
        <h6>Taps</h6>
      </ion-text>
        <ion-button color="success" size="small" fill="solid" shape="round" (click)="openAddTapModal()">
          <ion-icon slot="end" name="add-outline"> </ion-icon>
          Add
        </ion-button>
    </div>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @if(taps().length > 0) {
          <ion-list lines="full" class="ion-no-padding">
            @for(tap of taps(); track tap.id) {
              <ion-item>
                <ion-icon src="/assets/icons/flat/beer/tap.svg" slot="start"></ion-icon>
                <ion-label>{{ tap.name }}</ion-label>
                <ion-button (click)="confirmDeleteTap(tap)" fill="clear" slot="end">
                  <ion-icon name="trash-outline" color="danger"></ion-icon>
                </ion-button>
              </ion-item>
            }
          </ion-list>
        }
        @if(taps().length === 0) {
          <ion-item lines="none" class="ion-text-center">
            <ion-label>
              <h3>No taps assigned</h3>
              <p>This tower has no taps assigned yet</p>
            </ion-label>
          </ion-item>
        }

      </ion-card-content>
    </ion-card>
  </div>

  <div class="ion-padding-top">
    <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
      <ion-text color="medium">
        <h6>Fermenters</h6>
      </ion-text>
      <ion-button color="success" size="small" fill="solid" shape="round" (click)="openAddFermenterModal()" data-testid="tower-add-fermenter">
        <ion-icon slot="end" name="add-outline"> </ion-icon>
        Add
      </ion-button>
    </div>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @if(fermenters().length > 0) {
          <ion-list lines="full" class="ion-no-padding" data-testid="tower-fermenter-list">
            @for(fermenter of fermenters(); track fermenter.id) {
              <ion-item data-testid="tower-fermenter-item" [attr.data-fermenter-name]="fermenter.name">
                <ion-icon name="flask-outline" slot="start"></ion-icon>
                <ion-label>{{ fermenter.name }}</ion-label>
                <ion-button (click)="confirmDeleteFermenter(fermenter)" fill="clear" slot="end">
                  <ion-icon name="trash-outline" color="danger"></ion-icon>
                </ion-button>
              </ion-item>
            }
          </ion-list>
        }
        @if(fermenters().length === 0) {
          <ion-item lines="none" class="ion-text-center">
            <ion-label>
              <h3>No fermenters assigned</h3>
              <p>This tower has no fermenters assigned yet</p>
            </ion-label>
          </ion-item>
        }
      </ion-card-content>
    </ion-card>
  </div>

  <div class="ion-padding-top">
    <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
      <ion-text color="medium">
        <h6>CO2</h6>
      </ion-text>
      <ion-button color="success" size="small" fill="solid" shape="round" (click)="openAddCo2Modal()" data-testid="tower-add-co2">
        <ion-icon slot="end" name="add-outline"> </ion-icon>
        Add
      </ion-button>
    </div>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @if(co2Bottles().length > 0) {
          <ion-list lines="full" class="ion-no-padding" data-testid="tower-co2-list">
            @for(co2 of co2Bottles(); track co2.id) {
              <ion-item data-testid="tower-co2-item" [attr.data-co2-name]="co2.name">
                <ion-icon name="cellular-outline" slot="start"></ion-icon>
                <ion-label>{{ co2.name }}</ion-label>
                <ion-button (click)="confirmDeleteCo2(co2)" fill="clear" slot="end">
                  <ion-icon name="trash-outline" color="danger"></ion-icon>
                </ion-button>
              </ion-item>
            }
          </ion-list>
        }
        @if(co2Bottles().length === 0) {
          <ion-item lines="none" class="ion-text-center">
            <ion-label>
              <h3>No CO2 assigned</h3>
              <p>This tower has no CO2 bottles assigned yet</p>
            </ion-label>
          </ion-item>
        }
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>


